<template>
    <div class="container">

        <h1>Family Members</h1>


        <p class="fs-5 text-start text-secondary ps-3 pe-3" id="family">
            The Trollopes were a family of writers. Anthony's mother <span class="fst-italic">Frances</span>; brother <span class="fst-italic">Thomas</span>;
            Thomas' second wife <span class="fst-italic">Frances Eleanor</span>; his sister <span class="fst-italic">Cecilia</span>; and both his sons wrote books.
        </p>
        <hr class="mx-auto text-primary">
        <div id="text">
            <p class="text-start fs-6">
                Tempor orci eu lobortis elementum nibh tellus molestie nunc non. Egestas quis ipsum suspendisse ultrices
                gravida dictum fusce ut. Et netus et malesuada fames ac turpis egestas sed tempus. Nunc aliquet bibendum
                enim facilisis gravida neque. Volutpat consequat mauris nunc congue nisi vitae suscipit tellus. Hac
                habitasse platea dictumst quisque sagittis purus sit amet. Elit ut aliquam purus sit amet. Felis eget
                nunc lobortis mattis aliquam faucibus purus in massa. Faucibus pulvinar elementum integer enim. Morbi
                non arcu risus quis varius quam quisque. Tristique risus nec feugiat in fermentum posuere. Leo urna
                molestie at elementum eu. Faucibus scelerisque eleifend donec pretium vulputate. At risus viverra
                adipiscing at in tellus integer feugiat scelerisque. Turpis tincidunt id aliquet risus feugiat in ante
                metus dictum. Quisque sagittis purus sit amet volutpat consequat. Lectus sit amet est placerat in.
            </p>
            <p class="text-start fs-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Et molestie ac feugiat sed lectus. Ornare arcu dui vivamus arcu felis bibendum ut.
                Pharetra diam sit amet nisl suscipit adipiscing bibendum est. Interdum consectetur libero id faucibus.
                Scelerisque eu ultrices vitae auctor eu augue ut lectus. Sagittis id consectetur purus ut faucibus
                pulvinar elementum integer enim. Morbi blandit cursus risus at ultrices mi. Fringilla est ullamcorper
                eget nulla facilisi etiam dignissim diam quis. Massa eget egestas purus viverra accumsan in nisl nisi.
                Ornare massa eget egestas purus viverra accumsan in nisl. Duis convallis convallis tellus id interdum.
                Vitae elementum curabitur vitae nunc sed velit. Nam libero justo laoreet sit amet cursus sit amet.
                Ornare suspendisse sed nisi lacus sed viverra tellus.

            </p>
        </div>
    </div>

</template>

<script>

    // import NavBarSub from "@/components/Family/NavBarSub";

    export default {
        name: "Family",
        setup() {
            document.title = "Trollope - Family";
            return {
                meta: document.title
            }
        },
        components:{}  // {NavBarSub}
    }
</script>

<style scoped>
   /* p {
        text-align: left;
        font-size: 0.8em;
    }
    .spacer {
        background-color: aliceblue;
        margin-top: 0;
    }
    .name{
        font-style: italic;
    }*/
    hr{
        width: 40%;
        height: 2px;

    }
/*    #family{
        text-align: center;
    }*/
</style>